import { createSlice } from '@reduxjs/toolkit';

interface LoadingState {
  pendingActions: number;
}

const initialState: LoadingState = {
  pendingActions: 0
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    decrease(state) {
      --state.pendingActions;
    },
    increase(state) {
      ++state.pendingActions;
    }
  }
});

export const {
  decrease,
  increase

} = loadingSlice.actions;

export default loadingSlice.reducer;
